import React, { useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import logger from '../utils/logger';
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        gap: '20px'
    }
};

const AuthCallbackComponent = ({ onSuccess }) => {
    useEffect(() => {
        // logger.log('[AuthCallback] Component mounted');
        // logger.log('[AuthCallback] Current URL:', window.location.href);
        // logger.log('[AuthCallback] Has hash:', !!window.location.hash);
        
        try {
            // logger.log('[AuthCallback] Processing authentication callback');
            onSuccess();
        } catch (error) {
            logger.error('[AuthCallback] Error handling authentication:', error);
        }
    }, [onSuccess]);

    return (
        <div style={styles.container}>
            <CircularProgress />
            <div>Completing authentication...</div>
        </div>
    );
};

export default AuthCallbackComponent;